<section id="offerings" class="offerings">
  <div class="offerings-inner">
    <div class="offerings-head">
      <div>
        <div ppcEyebrow mark>{{ 'offerings.eyebrow' | translate }}</div>
        <h2 ppcHeading class="offerings-title">
          @for (line of titleLines(); track $index) {
            <span class="offerings-title-line">{{ line }}</span>
          }
        </h2>
      </div>
      <p ppcLead class="offerings-sub">{{ 'offerings.sub' | translate }}</p>
    </div>

    <div class="offerings-cards">
      @for (product of products(); track product.id; let index = $index) {
        <div class="offerings-card-slot">
          @if (isHighlighted(index)) {
            <div class="offerings-card-tab">{{ 'offerings.popular' | translate }}</div>
          }
          <article class="offerings-card" [class.offerings-card-highlight]="isHighlighted(index)">
            <h3 class="offerings-card-title"><span ppcEyebrow>{{ product.name }}</span></h3>
            <p class="offerings-card-desc">{{ product.description }}</p>
            <div class="offerings-card-price">
              <span class="offerings-card-currency">{{ 'offerings.currency' | translate }}</span>
              <span class="offerings-card-amount">{{ priceWhole(product) }}<span class="offerings-card-decimals">,{{ priceDecimals(product) }}</span></span>
              <span class="offerings-card-unit">{{ priceUnit(product).key | translate: priceUnit(product).params }}</span>
            </div>
            <hr class="offerings-card-rule" />
            <ul class="offerings-card-features">
              @for (feature of product.features; track $index) {
                <li>{{ feature }}</li>
              }
            </ul>
            <button ppcButton size="lg" [variant]="actionVariant(index)" type="button" class="offerings-card-action" (click)="pickPlan(product)">
              <span>{{ 'offerings.cta' | translate }}</span>
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true">
                <path d="M1 7H15M15 7L9 1M15 7L9 13" stroke="currentColor" stroke-width="1.6" />
              </svg>
            </button>
          </article>
        </div>
      }
    </div>

    <div class="offerings-note">{{ 'offerings.dayPassNote' | translate }}</div>
  </div>
</section>
